import { jsx } from "react/jsx-runtime";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { validateTidalLicense } from "../../base/index.js";
function KeyboardDoubleArrowLeft(props) {
  return /* @__PURE__ */ jsx(
    KeyboardDoubleArrowLeftIcon,
    {
      "data-testid": "KeyboardDoubleArrowLeft",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "KeyboardDoubleArrowLeft",
      "data-tidal-icon-meta": "arrows"
    }
  );
}
KeyboardDoubleArrowLeft.tidalIconMeta = {
  categories: "arrows",
  name: "KeyboardDoubleArrowLeft"
};
validateTidalLicense();
export {
  KeyboardDoubleArrowLeft
};
//# sourceMappingURL=KeyboardDoubleArrowLeft.js.map
